import React from "react";
import { Card, Row, Col, Typography, Select, Button, Table, Divider,Empty,ConfigProvider } from "antd";
import EmptyData from '../Assets/EmptyData.jpg';
const { Text } = Typography;
const { Option } = Select;


const columns = [
  { title: "#", dataIndex: "key", width: 40 },
  { title: "Raw Material", dataIndex: "material" },
  { title: "UOM", dataIndex: "uom", width: 60 },
  { title: "Net Issue", dataIndex: "net", align: "right", width: 100 },
  { title: "Gross", dataIndex: "gross", align: "right", width: 100 },
  { title: "Bags", dataIndex: "bags", align: "center", width: 80 }
];
const data = [
  { key: 1, material: "Rice", uom: "Kg", net: "380.00", gross: "381.00", bags: "1 bags" },
  { key: 2, material: "Wheat", uom: "Kg", net: "300.00", gross: "301.00", bags: "1 bags" },
  { key: 3, material: "Oil", uom: "Kg", net: "40.00", gross: "40.10", bags: "1 bags" },
  { key: 4, material: "Sugar", uom: "Kg", net: "120.00", gross: "120.10", bags: "1 bags" },
  { key: 5, material: "Vitamin", uom: "Kg", net: "5.00", gross: "5.10", bags: "1 bags" }
];

const JW_ReviewDC= () => (
  <Card style={{ margin: 24 }}>
    
    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
      <Col>
                <Text strong style={{ fontSize: 16,columnGap:20 }}>Delivery Challan — Jobwork Issue</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12,border:"1px  solid",borderRadius:"5px" }}>
                  MSPC: KARWAR • Month: Aug 2025 • PO: JWPO-202508-123
                </Text>
              </Col>
      <Col>
       <span style={{ fontWeight: 400 }}>MSPC: </span>
        <Select defaultValue="KARWAR" style={{ width: 120, marginRight: 10 }}>
          <Option value="KARWAR">KARWAR</Option>
        </Select>
         <span style={{ fontWeight: 400 }}>Month: </span>
        <Select defaultValue="Aug 2025" style={{ width: 120, marginRight: 10 }}>
          <Option value="Aug 2025">Aug 2025</Option>
        </Select>
        <Button style={{ marginRight: 8 }}>Load POs</Button>
        <Button>Load Draft</Button>
         <Col>
        <Button type="default" style={{ marginLeft:45,marginTop:10 }}>Save Draft</Button>
    </Col>
      </Col>
    </Row>
    <Row gutter={8} style={{ marginBottom: 16 ,justifyContent:"space-between"}}>
      <Col>
        <Button disabled>1. Select PO & RM</Button>
      </Col>
      <Col>
        <Button disabled>2. Pack & Weigh (Bags)</Button>
      </Col>
      <Col>
        <Button disabled>3. Transport</Button>
      </Col>
      <Col>
        <Button type="primary">4. Review & Generate</Button>
      </Col>
    
    </Row>
    <Text strong>Step 4 — Review & Generate Delivery Challan</Text>
    <Divider style={{ margin: "8px 0 16px 0" }} />

    
    <Row style={{ marginBottom: 10 }}>
      <Col span={14}>
        <Text>
          <b>DC For PO:</b> JWPO-202508-123 <br />
          MSPC: KARWAR &nbsp; Month: Aug 2025 <br />
          Jobworker: Sri Annapurna Millers
        </Text>
      </Col>
      <Col span={10}>
        <Text>
          <b>Vehicle:</b> KA-01-0223 &nbsp;  
          <b>LR:</b> Nil &nbsp;  
          <b>e-Way:</b> YES <br />
          <b>Dispatch:</b> 2025-09-10T18:32 &nbsp;  
          <b>Driver:</b> 90989 90989 <br />
          <b>Transporter:</b> SHIVA TRANSPORT <br />
          <b>Route:</b> MSPC-SHIVAMILLS
        </Text>
      </Col>
    </Row>
<ConfigProvider
              renderEmpty={() => (
                <Empty
                  image={EmptyData}
                  description="No CategoryMaster Data Available"
                  imageStyle={{ height: 200 }}
                />
              )}
            >
    
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={false}
      size="small"
      style={{ marginBottom: 16 }}
    />

  </ConfigProvider>
    <Row justify="end" gutter={8}>
      <Col>
        <Button>Back</Button>
      </Col>
      <Col>
        <Button type="primary">Generate DC</Button>
      </Col>
      <Col>
        <Button>Print / Save PDF</Button>
      </Col>
    </Row>
  </Card>
);

export default JW_ReviewDC;
